import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker';
import Select from "react-select";

import '/node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';

import "react-datepicker/dist/react-datepicker.css";
import '../assets/css/custom.css';
import '../assets/css/main.css';

import AutoSchBox from '../components/AutoSchBox'
import Footer from '../components/Footer'
import Intro from '../components/Intro'
import { options, AND, OR, NOT, images } from '../config'

import TFAILogoMain from '../assets/images/TFAI-logo-main.svg'
import defaultPic from '../assets/images/cnt-head-00.jpg'

const Home = () => {
    const [showModal, setShowModal] = useState(localStorage.getItem('hasShownModal') ? false : true)
    const [searchWord, setSearchWord] = useState(''); // 查詢關鍵字
    const [showAutofillList, setShowAutofillList] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [inputRef, setInputRef] = useState(0); // 輸入框的寬度
    const [selectedOptions, setSelectedOptions] = useState([]); //類別
    const [isAdvance, setIsAdvance] = useState(false)
    const [btnText, setBtnText] = useState('進階搜尋')
    const [placeholderText, setPlaceholderText] = useState('輸入多個搜尋關鍵字(上限5個)，用空格隔開表示and')
    const [data, setData] = useState([{ select: AND, input: "" }]); //進階查詢關鍵字

    const closeModal = () => {
        localStorage.setItem("hasShownModal", true);
        setShowModal(false)
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        window.addEventListener('click', handleOutsideClick);
        window.addEventListener('resize', handleResize);
        window.addEventListener('keypress', enterSearch);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
            window.removeEventListener('click', handleOutsideClick);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('keypress', enterSearch);
        };
    }, [showAutofillList]);

    const handleResize = () => {
        setInputRef(document.getElementById('input-keyword').clientWidth);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
            setShowAutofillList(false)
        }
    };

    const enterSearch = (event) => {
        if (event.key === 'Enter') {
            document.getElementById("submit").click()
        }
    };

    const handleOutsideClick = () => {
        setShowAutofillList(false)
    };

    const searchWordInput = (event) => {
        setInputRef(document.getElementById('input-keyword').clientWidth);
        setSearchWord(event.target.value)
        if (event.target.value !== "") {
            setShowAutofillList(true)
        } else {
            setShowAutofillList(false)
        }
    }

    let navigate = useNavigate();
    const handleSearch = () => {
        // 假設你有一個 search 函數處理查詢，並將查詢結果作為參數傳遞給 ResultPage
        // const searchResult = search(query);
        let sDate = ''
        let eDate = ''
        if (startDate) {
            sDate = startDate.getFullYear().toString()
        }
        if (endDate) {
            eDate = endDate.getFullYear().toString()
        }
        let advance = []
        if (isAdvance) {
            advance = data
        }
        // 使用 navigate.push 導航到 ResultPage 並將查詢結果作為 state 傳遞
        navigate(`/collection?keyWord=${searchWord}&advanceSearch=${JSON.stringify(advance)}&selectedOptions=${JSON.stringify(selectedOptions)}&startDate=${sDate}&endDate=${eDate}`);
    };

    const handleSelect = (selectedOptions) => {
        setSelectedOptions(selectedOptions)
    };

    const advanceBtn = () => {
        setIsAdvance(!isAdvance)
        setData([{ select: AND, input: "" }])
    }

    useEffect(() => {
        if (isAdvance) {
            setBtnText('一般查詢')
            setPlaceholderText('輸入一個搜尋關鍵字，其他關鍵字輸入在下方')
        } else {
            setBtnText('進階查詢')
            setPlaceholderText('輸入多個搜尋關鍵字(上限5個)，用空格隔開表示AND')
        }
    }, [isAdvance])

    const handleAdd = () => {
        const temp = [...data, { select: AND, input: "" }]
        setData(temp)
    }
    const handleChange = (onChangeValue, i) => {
        const { name, value } = onChangeValue.target
        const inputdata = [...data]
        inputdata[i][name] = value;
        setData(inputdata)
    }
    const handleDelete = () => {
        const delVal = [...data]
        delVal.splice(-1, 1)
        setData(delVal)
    }

    return (<>
        <div className="TFAI-box">
            <div id="landing">
                <div className="main-logo">
                    <img src={TFAILogoMain} alt="TFAT logo" className="img-fluid" />
                </div>
                <div id="index-search" className="col">
                    <form>
                        <div className="row g-1 mb-3">
                            <div className="col">
                                <div className="input-group mb-2">
                                    <input id="input-keyword" type="text" className="form-control" autoComplete="off"
                                        placeholder={placeholderText} value={searchWord} onChange={searchWordInput} />
                                    {showAutofillList && <AutoSchBox searchWord={searchWord} width={inputRef} setSearchWord={setSearchWord} />}
                                    <span id="submit" className="input-group-text btn-secondary" onClick={handleSearch} style={{ cursor: "pointer" }}><Search /></span>
                                </div>
                            </div>
                            <div className="col-auto">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#adv-search" onClick={advanceBtn}>
                                    {btnText}
                                </button>
                            </div>
                        </div>
                        <div id="adv-search" className="accordion-collapse collapse">
                            <div className="accordion-body" style={{ paddingTop: '0px', marginBottom: '10px' }}>
                                {data.map((val, index) => (
                                    <div key={index} className="row g-1 mb-3 mb-lg-1">
                                        <div className="col-auto">
                                            <select className="form-select" name="select" value={val.select} onChange={e => handleChange(e, index)}>
                                                <option value={AND}>AND</option>
                                                <option value={OR}>OR</option>
                                                <option value={NOT}>NOT</option>
                                            </select>
                                        </div>
                                        <div className="col">
                                            <input type="text" className="form-control" placeholder="" name="input" value={val.input} onChange={e => handleChange(e, index)}></input>
                                        </div>
                                        <div className="col-auto">
                                            {index === 0 ?
                                                <div>
                                                    <button id="addBtn" className="btn btn-secondary" type="button" style={{ marginLeft: '10px', width: '40px' }}
                                                        onClick={() => handleAdd()} disabled={data.length < 4 ? false : true}>+</button>
                                                    <button className="btn btn-secondary" type="button" style={{ marginLeft: '10px', width: '40px' }}
                                                        onClick={() => handleDelete()} disabled={data.length > 1 ? false : true}>-</button>
                                                </div>
                                                : <div style={{ width: '100px' }}></div>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="row g-1 mb-4">
                            <div className="input-group" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="col-auto d-none d-sm-inline-block">
                                    <label style={{ marginLeft: 10, marginRight: 25, display: 'flex', alignItems: 'center' }}>藏品類型</label>
                                </div>
                                <div className="col">
                                    <Select id="schType"
                                        isMulti
                                        options={options}
                                        value={selectedOptions}
                                        onChange={handleSelect}
                                        closeMenuOnSelect={false}
                                        placeholder="未選擇藏品類型，預設全選"
                                        noOptionsMessage={() => '已選擇所有藏品類型'}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                border: '1px solid #949494',
                                                boxShadow: 'none',
                                                "&:focus-within": {
                                                    borderColor: 'rgba(214, 217, 0, 0.9)',
                                                    boxShadow: '0 0 0 1px rgba(200, 144, 89, 0.25);',
                                                },
                                            }),
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row g-1 mb-3" style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="col-auto d-none d-sm-inline-block">
                                <label style={{ marginLeft: 10, marginRight: 25, display: 'flex', alignItems: 'center' }}>年代西元</label>
                            </div>
                            <div className="col">
                                <div className="row">
                                    <div className="col-4 col-md-4">
                                        <DatePicker className="form-control" placeholderText="西元年(起)"
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)} selectsStart
                                            startDate={startDate} endDate={endDate}
                                            dateFormat="yyyy" showYearPicker />
                                    </div>
                                    <div className="col-auto" style={{ display: 'flex', alignItems: 'center' }}>~</div>
                                    <div className="col-4 col-md-4">
                                        <DatePicker className="form-control" placeholderText="西元年(迄)"
                                            selected={endDate}
                                            onChange={(date) => setEndDate(date)} selectsEnd
                                            startDate={startDate} endDate={endDate}
                                            dateFormat="yyyy" showYearPicker />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="info-text"><p><a href='https://docs.google.com/forms/d/e/1FAIpQLScVm6ahjjAwmMD9aAFDKaaWhD1Hzxzcd5rXfO-50BcP7M0cSw/viewform'>平台使用滿意度調查</a></p></div>
                    </form>
                </div>
                <div style={{ width: '40%', margin: 'auto', fontSize: '20px', color: 'gray' }}>
                </div>
            </div>
            <div id="index-genre">
                <div className="row g-0">
                    {images.map((option, index) => {
                        // console.log("index："+index)
                        // console.log("length:"+options.length)
                        let columns = 6
                        if (images.length === 1) {
                            columns = 12
                        } else if (images.length === 2 || images.length === 4) {
                            columns = 6
                        } else if (images.length === 3 || images.length === 6 || images.length === 9) {
                            columns = 4
                        } else if (images.length === 5) {
                            if (index < 3) {
                                columns = 4
                            } else {
                                columns = 6
                            }
                        } else if (images.length === 7) {
                            if (index < 4) {
                                columns = 3
                            } else {
                                columns = 4
                            }
                        } else if (images.length === 8) {
                            columns = 3
                        }

                        return (
                            <div className={`col-12 col-md-6 col-lg-${columns} genre-item`} key={option.value}>
                                <Link to={`/collection?keyWord=&advanceSearch=[]&selectedOptions=[{"value":"${option.value}","label":"${option.label}"}]&startDate=&endDate=&page=1`} >
                                    <div className="genre-bg">
                                        {option.imageData ? (
                                            <img src={`data:image/jpeg;base64,${option.imageData}`} alt={option.label} />
                                        ) : (
                                            <img src={defaultPic} alt={option.label} />
                                        )}
                                    </div>
                                    <div className="genre-text">搜尋{option.label}</div>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
            <Footer />
        </div>

        {/* 首頁使用說明彈跳視窗 */}
        <Intro showModal={showModal} closeModal={closeModal} />
    </>);
};

export default Home;